import { render, staticRenderFns } from "./MailVorlageInhalt.vue?vue&type=template&id=1fe4cd97&"
import script from "./MailVorlageInhalt.vue?vue&type=script&lang=js&"
export * from "./MailVorlageInhalt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports